import Surface from "../primitives/Surface";
import { cn } from "../cn";

interface ComponentCardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  desc?: string;
  /**
   * @deprecated Glass is chrome-only — it cannot guarantee contrast over an
   * arbitrary backdrop, and these cards hold clinical copy. Accepted so the
   * existing call sites keep compiling; it no longer changes anything.
   */
  glass?: boolean;
}

/**
 * A titled card.
 *
 * Rebuilt on `Surface` rather than rewritten away: 23 screens call this, and
 * moving the implementation fixes all of them at once — the glass variant that
 * broke in dark mode, the `shadow-raised` drop on every card, and the hardcoded
 * greys. New code should reach for `Surface` and a `SectionLabel` directly;
 * this exists so the migration did not have to be a 23-file diff.
 */
const ComponentCard: React.FC<ComponentCardProps> = ({
  title,
  children,
  className = "",
  desc = "",
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  glass: _glass,
  ...props
}) => {
  return (
    <Surface padding="none" className={cn("overflow-hidden", className)} {...props}>
      <div className="px-5 py-4 sm:px-6 sm:py-5">
        <h3 className="text-base font-semibold text-content-primary">{title}</h3>
        {desc && <p className="mt-1 text-sm text-content-secondary">{desc}</p>}
      </div>

      <div className="border-t border-border-subtle p-5 sm:p-6">
        <div className="space-y-6">{children}</div>
      </div>
    </Surface>
  );
};

export default ComponentCard;
